import Rete from 'rete';
import Vue from 'vue';
import compose from 'lodash/flowRight';
import isArray from 'lodash/isArray';
import { acceptProps } from 'vue-compose';
import renameProps from '~lib/common/hoc/renameProps';

import dataView from '~lib/common/hoc/dataView';

function makeVueControl(Component, options = {}) {
  // If an array of options is passed
  // Run the makeVueControl for each options item
  // and return the final result
  if (isArray(options)) {
    const optionsArray = options;
    return optionsArray.reduce(
      (EnhancedComponent, optionsItem) =>
        makeVueControl(EnhancedComponent, optionsItem),
      Component,
    );
  }

  const enhance = options.query
    ? compose(
        dataView({ queries: { fetch: options.query } }),
        renameProps({ data: options.queryProp || 'data' }),
        acceptProps(['readonly', 'emitter', 'ikey', 'getData', 'putData']),
      )
    : C => C;
  const Container = enhance(Component);

  class ComponentControl extends Rete.Control {
    constructor(emitter, key) {
      super(key);
      this.component = Container;
      this.props = {
        emitter,
        ikey: key,
        control: this,
        ...(options.props || {}),
      };
      emitter.on('readonly', readonly => {
        if (!this.vueContext) {
          return;
        }
        // This will trigger an error in the console
        // because we are mutating a prop directly
        // but without access to the render method of the
        // parent component, we don't really have another way around it
        Vue.config.silent = true;
        this.vueContext.readonly = readonly;
        Vue.config.silent = false;
      });
    }

    setValue(val) {
      this.vueContext.value = val;
    }
  }

  return ComponentControl;
}

export default makeVueControl;
